import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiTwitter, FiInstagram, FiLinkedin } = FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Notice Section */}
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mx-4 mb-8 rounded-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <span className="text-2xl">⚠️</span>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-yellow-800 mb-2">Notice</h3>
            <p className="text-yellow-700 mb-4">
              This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
            </p>
            <p className="text-yellow-700 mb-4">
              🔒 We never share any client website made under this offer with others – your project privacy is 100% safe.
            </p>
            <a
              href="https://projects.azaansuperpc.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-yellow-800 font-medium hover:text-yellow-900"
            >
              👉 Check Offer
            </a>
          </div>
        </div>
      </div>

      <footer className="bg-secondary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold">BC</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold">BuildCorp</h3>
                  <p className="text-sm text-gray-400">Construction Excellence</p>
                </div>
              </div>
              <p className="text-gray-300 mb-4">
                Building dreams with precision, quality, and innovation. Your trusted construction partner for over 20 years.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                  <SafeIcon icon={FiFacebook} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                  <SafeIcon icon={FiTwitter} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                  <SafeIcon icon={FiInstagram} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-primary transition-colors">
                  <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-300 hover:text-primary transition-colors">Home</Link></li>
                <li><Link to="/about" className="text-gray-300 hover:text-primary transition-colors">About Us</Link></li>
                <li><Link to="/services" className="text-gray-300 hover:text-primary transition-colors">Our Services</Link></li>
                <li><Link to="/projects" className="text-gray-300 hover:text-primary transition-colors">Projects</Link></li>
                <li><Link to="/contact" className="text-gray-300 hover:text-primary transition-colors">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Our Services</h4>
              <ul className="space-y-2">
                <li><span className="text-gray-300">Residential Construction</span></li>
                <li><span className="text-gray-300">Commercial Building</span></li>
                <li><span className="text-gray-300">Renovation & Remodeling</span></li>
                <li><span className="text-gray-300">Project Management</span></li>
                <li><span className="text-gray-300">Consulting Services</span></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-primary" />
                  <span className="text-gray-300">123 Construction Ave, Building City, BC 12345</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-primary" />
                  <span className="text-gray-300">+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="w-5 h-5 text-primary" />
                  <span className="text-gray-300">info@buildcorp.com</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © {currentYear} BuildCorp. All rights reserved.
              </p>
              <p className="text-gray-400 text-sm mt-2 md:mt-0">
                Domain + Hosting + Design = <a href="https://account4web.ca" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-orange-400">Account4Web Inc</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;